import { Component, Input, Output, EventEmitter, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../../ui/modal/modal.component';
import { TokenExpirationService } from '../../../services/token-expiration.service';

@Component({
  selector: 'app-token-expiration-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './token-expiration-modal.component.html'
})
export class TokenExpirationModalComponent implements OnDestroy {
  private tokenExpirationService = inject(TokenExpirationService);
  
  @Input() isOpen = false;
  @Input() timeRemaining = 300; // seconds; default fallback (parent normally passes from modalState$ or defaultWarningDuration)
  @Input() sessionExpired = false; // true when showing session expired message
  @Output() continueSession = new EventEmitter<void>();
  @Output() logoutNow = new EventEmitter<void>();

  get formattedTime(): string {
    return this.tokenExpirationService.formatTimeRemaining(this.timeRemaining);
  }

  onContinueSession(): void {
    this.continueSession.emit();
  }

  onLogoutNow(): void {
    this.logoutNow.emit();
  }

  onRefresh(): void {
    // On login page, just close the modal. On other pages, logout/redirect
    if (this.sessionExpired) {
      // Close the modal when on login page
      this.tokenExpirationService.hideModal();
    } else {
      this.logoutNow.emit();
    }
  }

  ngOnDestroy(): void {
    // Component cleanup if needed
  }
}
